import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  NgZone,
} from '@angular/core';
import { StudioService } from '../services/studio.service';
import { ActivatedRoute, Router } from '@angular/router';
import {AlertController, LoadingController, ModalController} from '@ionic/angular';
import { Geolocation } from '@ionic-native/geolocation/ngx';

import * as _ from 'lodash';
import * as moment from 'moment';
import { timeout } from 'rxjs/operators';
import { PromotionFiltersPage } from '../modals/promotion-filters/promotion-filters.page';
import { StudioFiltersPage } from '../modals/studio-filters/studio-filters.page';
import { Facebook } from '@ionic-native/facebook/ngx';
import { TimezoneService } from '../services/timezone.service';
import { EnvService } from '../env.service';
declare var google;
declare var amplitude;
class StudioModel {
  classScheduleList?: [];
  id?: any;
  lat?: any;
  lng?: any;
  name?: string;
  title?: string;
  street_address?: string;
  city?: string;
  province_state?: string;
  description?: string;
  postal_zip?: string;
  term_prices?: string;
  image_file_exist?: string;
  username?: string;
  time_zone?: string;
}
@Component({
  selector: 'app-studio',
  templateUrl: './studio.page.html',
  styleUrls: ['./studio.page.scss'],
  providers: [Geolocation],
})
export class StudioPage implements OnInit {
  @ViewChild('studioMapContainer', { static: false }) gmap: ElementRef;
  map: google.maps.Map;
  directionsService = new google.maps.DirectionsService();
  directionsDisplay = new google.maps.DirectionsRenderer();
  twitterShareUrl: string;
  emailBody: string;
  studioList = [];
  studio: StudioModel = {};
  classType = '';
  classTypeList = [];
  classTimings = [
    {
      name: 'Morning',
      isSelected: true,
      start: '00:00',
      end: '12:00',
    },
    {
      name: 'Afternoon',
      isSelected: true,
      start: '12:00',
      end: '17:00',
    },
    {
      name: 'Evening',
      isSelected: true,
      start: '17:00',
      end: '24:00',
    },
  ];
  // dateFilter = moment(new Date()).toISOString();
  dateFilter = 'year';

  // let mapPromise;
  // let directionsDisplay = new google.maps.DirectionsRenderer();
  showMap = false;
  loadingStudioData = true;
  datePickerOptins = {
    showButtonBar: true,
  };
  classSchdList: any[] = [];
  venueClassesList: any[] = []
  public instructorList: any[] = [];
  termPlans: any[] = [];
  classSchdListOriginal: any;
  studioId: string;
  classId: string;
  isLoading = false;
  filters = {};
  public userTimezone;
  public venueTimezone;
  public isIframeLoader = false;
  public userLoggedIn = false;
  constructor(
    private studioService: StudioService,
    private route: ActivatedRoute,
    private loadingCtrl: LoadingController,
    private ngZone: NgZone,
    private geolocation: Geolocation,
    private router: Router,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private fb: Facebook,
    public timezoneService: TimezoneService,
    private env: EnvService
  ) {
    this.route.queryParams.subscribe((params) => {
      if (params.classId) {
        this.classId = params.classId;
      }
    });
    this.route.params.subscribe((params) => {
      if (params.id) {
        this.showLoader();
        this.studioId = params.id;
        this.getVenueDetails(this.dateFilter);
      }
    });
    let currentUser = JSON.parse(localStorage.getItem('pToken'));
    if(currentUser && currentUser.user && currentUser.first_name){
      this.userLoggedIn = true;
    }
    this.userTimezone = timezoneService.getUserTimezone();
    amplitude.logEvent("mobile::visited_venue_page", {'venueId': this.studioId, 'classId': this.classId});
  }

  ngOnInit() {}
  createShareMessage() {
    if (this.studio) {
      const nl = encodeURI('\n\r');
      const emailMessageBody =
        'Hi' +
        nl +
        nl +
        'Check out this cool studio ' +
        this.studio.name +
        ' on Promoga!' +
        nl +
        nl +
        this.env.BASE_URL+'venue/'+this.studioId +
        nl +
        nl +
        'Cheers,';
      this.emailBody = emailMessageBody;
      this.twitterShareUrl =
        'https://twitter.com/intent/tweet?' +
        'url=' +
        this.env.BASE_URL+'venue/'+this.studioId+
        '&text=' +
        'Promoga Promotion';
    }
    this.isIframeLoader = window !== window.parent;
  }
  shareFacebook() {

    const options: any  = {
      method: 'share',
      href: this.env.BASE_URL+'venue/'+this.studioId,
      caption: '',
      description: '',
      picture: '',
      hashtag: '',
      fallback_redirect_uri: this.env.BASE_URL+'venue/'+this.studioId,
      share_feedWeb: true, // iOS only
    };
    this.fb.showDialog(options)
    .then(res => {
        console.log(res, 'shared fb object');
      })
    .catch(e => console.log('Error logging into Facebook', e));
  }

  loadMap(lat = 49.2569777, lng = -123.123904) {
    const location = {
      lat: parseFloat(lat.toString()),
      lng: parseFloat(lng.toString()),
    };
    const mapOptions = {
      center: location,
      minZoom: 10,
      zoom: 12,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      zoomControl: true,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL,
        position: google.maps.ControlPosition.LEFT_TOP,
      },
    };
    this.map = new google.maps.Map(this.gmap.nativeElement, mapOptions);
    const markerOptions = {
      position: location,
      map: this.map,
      title: this.studio.name,
      icon: 'assets/images/map-icon-light.png',
    };
    const marker = new google.maps.Marker(markerOptions);
    this.directionsDisplay.setMap(this.map);
  }

  getDirections() {
    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };

    function success(pos) {
      const crd = pos.coords;
      console.log('Your current position is:');
      console.log(`Latitude : ${crd.latitude}`);
      console.log(`Longitude: ${crd.longitude}`);
      console.log(`More or less ${crd.accuracy} meters.`);
    }

    function error(err) {
      console.warn(`ERROR(${err.code}): ${err.message}`);
    }

    navigator.geolocation.getCurrentPosition(success, error, options);
  }

  getFilteredDate(filter, venueDate) {
    const currDate = moment();
    const tmrw = moment().add(1, 'day');
    const diff = moment(venueDate).diff(currDate, 'days');
    switch (filter) {
      case 'tomorrow':
        return moment(venueDate).isSame(tmrw, 'day');
      case 'today':
        return moment(venueDate).isSame(currDate, 'day')
      case 'week':
         return (diff < 6);

      case 'month':
        return (diff >= 0 && diff < 29 );
      case 'year':
        return (diff >= 0);

    }
  }

  buyTermPlan(plan) {
    this.router.navigate(['/venue', this.studio.id, 'buy', plan.id]);
  }

  getVenueDetails(dateFilter) {
    const vm = this;
    this.loadingStudioData = true;
    this.studioService.getStudioByUsername(this.studioId, this.classId, {}).subscribe(
      (response: any) => {
        this.hideLoader();
        const studio: StudioModel = this.removeInactiveSessions(response.result);
        this.studio = studio;
        this.venueTimezone = studio.time_zone;
        this.loadingStudioData = false;
        this.showMap = true;
        setTimeout(() => {
          this.loadMap(studio.lat, studio.lng);
        }, 500);
        this.createShareMessage();
        this.classSchdList = [];
        this.instructorList = [];
        this.classTypeList = [];
        this.termPlans = [];
        this.venueClassesList = [];

        Object.keys(studio.classScheduleList).forEach((item) => {
          studio.classScheduleList[item] = studio.classScheduleList[
            item
          ].filter(vm.withoutOldSessions);
          studio.classScheduleList[item] = studio.classScheduleList[
            item
          ].filter(vm.doFilter);
          studio.classScheduleList[item].forEach((data) => {
            data.categoryList = data.categories
              .filter((cat) => {
                return cat.cat_parent !== 0;
              })
              .map(function(v) {
                return v.cat_name;
              })
              .filter((k) => {
                return k !== 'Class' && k !== 'Bootcamp' && k !== 'Workshop';
              });

              let isOnlineClass = data.promotion.classes.online_locations && data.promotion.classes.online_locations.length > 0;
              //Convert schedule to user timezone 
              let timeStart = this.timezoneService.convertUtcToUserTimezoneWithDayLight(item + " " + data.schedule.starttime, data.promotion.classes.first_session, isOnlineClass, this.venueTimezone);
              data.schedule.starttime = timeStart.toTimeString().split(' ')[0];
              data.classStartDate = timeStart.toLocaleDateString('en-CA');
              
              let timeEnd = this.timezoneService.convertUtcToUserTimezoneWithDayLight(item + " " + data.schedule.endtime, data.promotion.classes.first_session, isOnlineClass, this.venueTimezone);
              data.schedule.endtime = timeEnd.toTimeString().split(' ')[0];

            data.startTime = vm.convertoAMPM(data.schedule.starttime);
            data.isOnlineClass = isOnlineClass;
           
            if(timeStart > timeEnd){
               timeEnd.setDate(timeEnd.getDate() + 1);
            }
       
            // let minutes = timeEnd.getMinutes() - timeStart.getMinutes();
            // const hrs = timeEnd.getHours() - timeStart.getHours();
            // minutes += hrs * 60;
            data.classDuration = Math.round((timeEnd.getTime() - timeStart.getTime()) / 60000) + ' mins';

            if (data.instructor){
              if ((data.instructor.is_invited == 1 && data.instructor.invitation_status !== 'ACCEPTED') ||
              (data.instructor.is_invited == 1 && data.instructor.invitation_status == 'ACCEPTED' && !data.instructor.is_profile_completed)) {
                  data.instructor = data.promoter;
              }
            }

            if (
              vm.instructorList.filter((item) => {
                return item.id === data.instructor.id;
              }).length === 0
            ) {
              data.instructor.isSelected = true;
              vm.instructorList.push(data.instructor);
            }
            data.categories.forEach((cat) => {
              if (
                vm.classTypeList.filter((item) => {
                  return item.id === cat.id;
                }).length === 0
              ) {
                cat.isSelected = true;
                if (
                  cat.cat_name !== 'Class' &&
                  cat.cat_name !== 'Bootcamp' &&
                  cat.cat_name !== 'Workshop'
                ) {
                  vm.classTypeList.push(cat);
                }
              }
            });
            this.venueClassesList.push(data);
          });
          // vm.classSchdList.push({
          //   date: item,
          //   classes: studio.classScheduleList[item].sort((a, b) => {
          //     return a.name.toLowerCase().charCodeAt(0) < b.name.toLowerCase().charCodeAt(0) ?  - 1 : 1;
          //   })
          // });
        });

        //PBL-914 Dates showing without changing timezone - fix
        this.venueClassesList.forEach((cls)=>{
          var existingList = this.classSchdList.filter((schedule) => {
            return schedule.date === cls.classStartDate;
          })[0];
          
          if (existingList) {
              existingList.classes.push(cls);
          } else {
              this.classSchdList.push({ date: cls.classStartDate, classes: [cls] });
          }
       });

        this.classSchdList = this.classSchdList.sort(
          (a, b) => moment(a.date).valueOf() - moment(b.date).valueOf()
        );

        //To order by time
        this.classSchdList.forEach((data) => {
          data.classes.sort((a,b)=>{
            let timeA = new Date(`1970-01-01T${a.schedule.starttime}`);
            let timeB = new Date(`1970-01-01T${b.schedule.starttime}`);
            if (!timeA || !timeB) {
              return 0; // handle invalid time values
            }      
            return timeA.getTime() - timeB.getTime();
          });
        });
        this.classSchdListOriginal = _.cloneDeep(this.classSchdList);
         this.removeDuplicatedClasses(this.classSchdListOriginal);
       // this.onClassTypeChange('Class');
        const tt = {};
        this.classTypeList.forEach(function(item) {
          if (item.cat_parent !== 0) {
            if (!tt[item.cat_parent]) {
              tt[item.cat_parent] = [];
            }
            tt[item.cat_parent].push(item);
          }
        });
        Object.keys(tt).forEach(function(v, k) {
          vm.classTypeList.forEach(function(item) {
            if (item.cat_parent === 0) {
              item.childCat = tt[item.id];
            }
          });
        });
        this.classTypeList = this.classTypeList.filter(function(item) {
          return item.cat_parent === 0;
        });
        this.filterScheduleList();
      },
      (err) => {
        this.loadingStudioData = false;
        this.hideLoader();
      }
    );
  }
  withoutOldSessions(venue) {
    const now = moment();
    venue.promotion &&
      (venue.promotion.next_sessions = _(venue.promotion.next_sessions)
        .filter(function(session) {
          return now.isBefore(session.startdate);
        })
        .value());
    return venue;
  }

 removeInactiveSessions(venue){
    Object.keys(venue.classScheduleList).forEach((key)=>{
      let promotions = venue.classScheduleList[key].filter((data)=>{
      let sessions =  data.promotion.classes.sessions;
      let hasActiveSession = false;
            sessions.map((session)=>{
              let startdate;
              venue.classScheduleList[key].forEach((cls)=>{
                 if(cls.promotion.classes.id == data.promotion.classes.id && cls['schedule']){
                  startdate = cls['schedule']['startdate'];
                 }
              });
                if(session.active == 1 && startdate != session.startdate&& moment(session.startdate).format('L') === moment(key).format('L') && !data['schedule']){
                    let starttime = session.startdate.split(" ")[1];
                    hasActiveSession = true;
                    data['schedule'] = this.getScheduleForSession(key, data.schedules, starttime);
                    data['schedule']['startdate'] = session.startdate;
                    data.promotion.classes['schedule'] = data['schedule'];
                }          
            });
            if(hasActiveSession){
                return data;
            }
     });
     if(promotions && promotions.length > 0){
        venue.classScheduleList[key] = promotions;
     } else {
         delete venue.classScheduleList[key];
     }               
    });
    return venue;
 }

  getScheduleForSession(date, schedules, starttime){
      let days = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
      let filteredSchedule = schedules.filter((schedule)=>{
          if(schedule.day == days[new Date(date+" 00:00").getDay()] && starttime == schedule.starttime){
              return schedule;
          }
      });
      return filteredSchedule && filteredSchedule[0] ? filteredSchedule[0] : schedules[0];
  }

  doFilter(item) {
    return (
      Array.isArray(item.promotion.next_sessions) &&
      item.promotion.next_sessions.length > 0
    );
  }

  onClassTypeChange(classType) {
    this.classSchdList = _.cloneDeep(this.classSchdListOriginal);
    this.classSchdList.forEach((item) => {
      item.classes = item.classes.filter((clss) => {
        return (
          clss.categories
            .map((cat) => {
              return cat.cat_name;
            })
            .join(',')
            .indexOf(classType) > -1
        );
      });
    });
  }
  onDateChange(date) {
    this.getVenueDetails(date);
  }
  convertoAMPM(timeString) {
    const hourEnd = timeString.indexOf(':');
    const H = +timeString.substr(0, hourEnd);
    const h = H % 12 || 12;
    const ampm = H < 12 ? 'AM' : 'PM';
    timeString = h + timeString.substr(hourEnd, 3) + ampm;
    return timeString;
  }
  removeDuplicatedClasses(list) {
    list.forEach((item) => {
      const uniqueClasses = [];
      const unique = [];
      const uniqueStartTime = [];     
      item.classes.forEach((cls) => {
        if (unique.indexOf(cls.promotion.class_id) === -1 || uniqueStartTime.indexOf(cls.schedule.starttime) === -1) {
          unique.push(cls.promotion.class_id);
          uniqueStartTime.push(cls.schedule.starttime);
          uniqueClasses.push(cls);
        } 
      });
       item.classes = uniqueClasses;
    });
  }
  showLoader() {
    this.isLoading = true;
    this.loadingCtrl
      .create({
        message: 'Loading...',
      })
      .then((res) => {
        res.present().then(()=>{
          //To avoid loader overlapping
          if (!this.isLoading) {
            res.dismiss().then(() => {});
          }      
        });

        res.onDidDismiss().then((dis) => {});
      });
  }
  hideLoader() {
    this.isLoading = false;
    this.loadingCtrl.dismiss();
  }
  showInstructor(usr) {
    this.router.navigate(['/' + usr.username]);
  }
  searchPromotions() {
    let params = this.getBoundingBox();
    params['venue_id'] = this.studio.id;
    this.router.navigate(['/search/promotions'], {
      queryParams: params
    }).then(() => {
      // window.location.reload();
    });
  }
  searchPromotions2(cls) {
    let params = this.getBoundingBox();
    params['class_id'] = cls.promotion.class_id;  
    this.router.navigate(['/search/promotions'], {
      queryParams: params
    });
  }

  getBoundingBox() {
  const resLat = parseFloat(this.studio.lat);
  const resLng = parseFloat(this.studio.lng);

  const offsetLat = 0.35;
  const offsetLng = 0.35;

  return {
    sw_lat: (resLat - offsetLat).toFixed(10),
    sw_lng: (resLng - offsetLng).toFixed(10),
    ne_lat: (resLat  + offsetLat).toFixed(10),
    ne_lng: (resLng  + offsetLng).toFixed(10),
    resLat: this.studio.lat,
    resLng: this.studio.lng                                    
  };
}
  async presentModal() {
    const modal = await this.modalCtrl.create({
      component: StudioFiltersPage,
      componentProps: {
        filters: this.filters,
        instructorList: this.instructorList,
        classTimings: this.classTimings,
        classTypeList: this.classTypeList,
        classType: this.classType,
        dateFilter: this.dateFilter,
      },
    });

    modal.onDidDismiss().then((modalData) => {
      this.filters = modalData.data;
      this.classType = modalData.data.filters.classType;
      this.classTypeList = modalData.data.filters.classTypeList;
      this.classTimings = modalData.data.filters.classTimings;
      this.instructorList = modalData.data.filters.instructorList;
      this.dateFilter = modalData.data.filters.dateFilter;

      this.filterScheduleList();
    });
    return await modal.present();
  }
  segmentChanged(ev: any) {
    const b = document.getElementById(ev.detail.value);
    if (b) { b.scrollIntoView({ behavior: 'smooth' }); }
  }
  filterScheduleList() {
    const vm = this;

    this.classSchdList = _.cloneDeep(this.classSchdListOriginal);
    this.classSchdList.forEach((item) => {
      item.classes = item.classes.filter((clss) => {
        return (
          clss.categories
            .map((cat) => {
              return cat.cat_name;
            })
            .join(',')
            .indexOf(this.classType) > -1
        );
      });
    });
    const selectedInstructors = this.instructorList.filter((item) => {
      return item.isSelected;
    });
    const selectedCategories = [];
    this.classTypeList.forEach((item) => {
      const selectedChildCnt = item.childCat.filter((i) => {
        return i.isSelected;
      }).length;
      if (item.isSelected || selectedChildCnt > 0) {
        if (selectedChildCnt > 0) {
          item.isSelected = true;
          item.childCat.forEach((child) => {
            if (child.isSelected) {
              selectedCategories.push(child);
            }
          });
        } else {
          item.isSelected = false;
        }
      } else {
        item.childCat.forEach((child) => {
          child.isSelected = false;
        });
      }
    });
    const selectedTimings = this.classTimings.filter((item) => {
      return item.isSelected;
    });
    if (
      selectedCategories.length > 0 &&
      selectedTimings.length > 0 &&
      selectedInstructors.length > 0
    ) {
      const filteredData = [];
      this.classSchdList.forEach((item) => {
        const timeZone = new Date().getTimezoneOffset() * 60 * 1000;
        const venueDate = new Date(item.date).getTime() + timeZone;
       // var selectedDate = new Date(vm.dateFilter).setHours(0, 0, 0, 0);
        if (vm.getFilteredDate(this.dateFilter, venueDate)) {
          const filteredClass = item.classes.filter((clss) => {
            for (let i = 0; i < selectedInstructors.length; i++) {
              const instItem = selectedInstructors[i];
              clss.hasInst = false;
              if (clss.instructor.id === instItem.id) {
                clss.hasInst = true;
                break;
              }
            }
            for (let j = 0; j < selectedCategories.length; j++) {
              const catItem = selectedCategories[j];
              clss.hasCat = false;
              if (clss.categoryList.join(',').indexOf(catItem.cat_name) > -1) {
                clss.hasCat = true;
                break;
              }
            }
            for (let k = 0; k < selectedTimings.length; k++) {
              const timeItem = selectedTimings[k];
              const classTimeStart = new Date(
                item.date + ' ' + clss.schedules[0].starttime
              );
              const start = new Date(item.date + ' ' + timeItem.start);
              const end = new Date(item.date + ' ' + timeItem.end);
              clss.hasTime = false;
              if (classTimeStart >= start && classTimeStart < end) {
                clss.hasTime = true;
                break;
              }
            }
            return clss.hasTime && clss.hasCat && clss.hasInst;
          });
          if (filteredClass.length > 0) {
            filteredData.push({
              date: item.date,
              classes: filteredClass,
            });
          }
        }
      });
      this.classSchdList = filteredData;
    } else {
      this.classSchdList = [];
    }
  }

  async openTooltip(event) {
    event.stopPropagation();
    const alert = await this.alertCtrl.create({
      message: 'Online events are displayed in your local timezone.',
      buttons: ['OK']
    });
    await alert.present();
  }

  scrollPage(id){
    let element = document.getElementById(id);
    element.scrollIntoView({behavior: 'smooth'});
  }
}
